import PocketBase from 'pocketbase';

export const pb = new PocketBase('https://pb.henselx.it');
